
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment";
import { useAuthState } from '../../../../Helper/Context';
import { WorkAssignedTableDataAPI } from '../../../../Redux/GardenDashboardSlice/WorkAssignedSlice';
import { Loading } from '../../../../Helper/Loading';
import Sidebar from '../../../../Components/Sidebar/Sidebar';
import Header from '../../../../Components/Header/Header';
import { WardNameDataDDL } from '../../../../Components/CommonDDL/WardNameDataDDL';
import { WorkAssignByDDL } from '../../../../Components/CommonDDL/WorkAssignByDDL';
import { AssetTypeDataDDL } from '../../../../Components/CommonDDL/AssetTypeDataDDL';
import { Pegination } from '../../../../Components/Pegination/Pegination';
import ViewURL from '../../../../Components/ViewURL/ViewURL';
import { WorkTypeDDL } from '../../../../Components/CommonDDL/WorkTypeDDL';
import { GardenCompletedWorkPDFReportTableDataAPI, GardenCompletedWorkReportTableDataAPI } from '../../../../Redux/ReportsSlice/GardenCompletedWorkReportsSlice';
import { toastErrorr } from '../../../../Helper/ToastMessage';
import { AssetDataDDL } from '../../../../Components/CommonDDL/AssetDataDDL';

export default function CompletedWorkReport() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let FlagName = searchParams.get("Flag")

    // console.log(FlagName)

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })
    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: HYear && HYear ? HYear : '0',
        Label: YLable && YLable ? YLable : "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: HMonth && HMonth ? HMonth : '0',
        Label: MLable && MLable ? MLable : "Select...",

    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '1',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WorkAssignedBy, setWorkAssignedBy] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [AssetType, setAssetType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [AssetName, setAssetName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [Heading, setHeading] = React.useState(false)
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [PDFUrl, setPDFUrl] = useState('')

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setWardName({
            ...WardName,
            ID: WardName.DDL[0].value,
            Label: WardName.DDL[0].label,
        })
        setAssetType({
            ...AssetType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }

    const handlePost = () => {
        setIsPost(!IsPost)
    }

    const handleGetPDFUrl = (pdfUrl) => {
        // console.log('pdfUrl',pdfUrl)
        if (pdfUrl && pdfUrl != '') {
            window.open(pdfUrl)
            // setPDFUrl(pdfUrl)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleOpenPdf = () => {
        window.open(PDFUrl)
    }


    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [PDFLoader, setPDFLoader] = useState(false)

    const handleGetPDF = () => {
        const data = {
            UserID: UserID,
            token: token,
            M_ProjectID: '0',
            FromDate: FromDate,
            M_WardID: WardName.ID,
            ToDate: ToDate,
            M_WorkTypeID: WorkType.ID,
            M_AssetTypeID: AssetType.ID,
            M_AssetID: AssetName.ID,
            M_WorkID: '0',
            Flag: 'PDF_Report',
            handleGetPDFUrl: handleGetPDFUrl,
            setPDFLoader: setPDFLoader
        }
        if (WardName.ID != '0') {
            dispatch(GardenCompletedWorkPDFReportTableDataAPI({ data }))
        }

    }

    useEffect(() => {
        const data = {
            UserID: UserID,
            token: token,
            M_ProjectID: '0',
            FromDate: FromDate,
            M_WardID: WardName.ID,
            ToDate: ToDate,
            M_WorkTypeID: WorkType.ID,
            M_AssetTypeID: AssetType.ID,
            M_AssetID: AssetName.ID,
            M_WorkID: '0',
            Flag: 'Grid',
            // handleGetPDFUrl: handleGetPDFUrl
        }
        // if (WardName.ID != '0') {
        dispatch(GardenCompletedWorkReportTableDataAPI({ data }))
        // }
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.GardenCompletedWorkReportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId} active='completedWorkReport' />
                    <div id="" className='content1'>
                        <div className='data_mob'>
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='col-8'>
                                    <h5 className="ps-1 pt-1">Completed Work Report</h5>
                                </div>
                                <div className='col-4'>
                                    {/* <button type="button" className="btn btn-primary float-end mr-1">Export</button> */}

                                    <button type="button" className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                        onClick={handleGetPDF}
                                        disabled={PDFLoader}
                                    >
                                        {
                                            PDFLoader ?
                                                <>
                                                    <i
                                                        className="fa fa-spinner fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    ></i> Loading
                                                </>
                                                :
                                                <>
                                                    <i className='fas fa-file-pdf mx-2'></i>
                                                    PDF
                                                </>
                                        }

                                    </button>
                                </div>

                                <div className="row m-0 mt-1">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12 ">
                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-3 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            // min={moment().startOf('month').format('YYYY-MM-DD')}
                                                            max={moment().format('YYYY-MM-DD')}
                                                            onChange={(e) => (setFromDate(e.target.value), setToDate(''))} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>To Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            min={FromDate ? FromDate : moment(FromDate).format('YYYY-MM-DD')}
                                                            // max={moment().format('YYYY-MM-DD')}
                                                            onChange={(e) => setToDate(e.target.value)} />

                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        // HWard={HWard}
                                                        // WLable={WLable}
                                                        Flag='Ward'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                        isDisplay={true}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <AssetTypeDataDDL
                                                        AssetType={AssetType}
                                                        setAssetType={setAssetType}

                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3">
                                                    <AssetDataDDL
                                                        AssetName={AssetName}
                                                        setAssetName={setAssetName}
                                                        M_AssetTypeID={AssetType.ID}

                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-2 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <div className='d-flex pt-3' style={{ marginTop: "-1em" }}>
                                                        <button type="button"
                                                            className="btn-clear btn btn-primary mx-2"
                                                            onClick={handleSearch}
                                                        >
                                                            Search</button>
                                                        <button type="button"
                                                            className="btn btn-outline-danger"
                                                            onClick={handleClear}
                                                        >
                                                            Clear</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Sector Name	 </th>
                                                            <th>Work Name </th>
                                                            <th>Work Assign By</th>
                                                            <th>Assign Date</th>
                                                            <th>Asset Type</th>
                                                            <th>Asset Name</th>
                                                            <th>Work Done Date</th>
                                                            <th>Before Work Photo</th>
                                                            <th>After Work Photo</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item, i) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                                                                    <td>{item.sectorname ? item.sectorname : '-'}</td>
                                                                    <td>{item.workName ? item.workName : '-'}</td>
                                                                    <td>{item.workAssignedBy ? item.workAssignedBy : '-'}</td>
                                                                    <td>{item.uploadDate ? item.uploadDate : '-'}</td>
                                                                    <td>{item.assetTypeName ? item.assetTypeName : '-'}</td>
                                                                    <td>{item.assetName ? item.assetName : '-'}</td>
                                                                    <td>{item.workDoneDate ? item.workDoneDate : '-'}</td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.beforePhotoPath == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye"
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleShowImage(item.beforePhotoPath),
                                                                                            setHeading("Assign Work Photo")
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.afterPhotoPath == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye"
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleShowImage(item.afterPhotoPath),
                                                                                            setHeading("Assign Work Photo")
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>

                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            } */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <!--  --> */}


                    </div>
                </div>
                {
                    showImagePopup ?
                        <ViewURL
                            Heading={Heading}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''
                }
            </div >
        </>

    )
}